
(function() { 
    const canUseHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function parseMediaIds(rawValue) {
        if (!rawValue || typeof rawValue !== 'string') return [];
        return rawValue
            .split(',')
            .map(function(id) { return id.trim(); })
            .filter(function(id) { return id.length > 0; });
    }

    function ensureCardSlideCache(swiperContainer) {
        if (!swiperContainer) return [];
        if (!swiperContainer.__allSlidesCache) {
            const slides = Array.from(swiperContainer.querySelectorAll('.swiper-slide'));
            swiperContainer.__allSlidesCache = slides.map(function(slide) {
                return {
                    id: slide.getAttribute('data-media-id') || '',
                    html: slide.outerHTML
                };
            });
        }
        return swiperContainer.__allSlidesCache || [];
    }

    function resetCardSlideCache(cardOrRoot) {
        if (!cardOrRoot) return;
        const scope = cardOrRoot.matches && cardOrRoot.matches('.CollectionSliderCard')
            ? cardOrRoot
            : cardOrRoot;
        const swipers = scope.querySelectorAll
            ? scope.querySelectorAll('.CollectionSliderCard__InnerSlider')
            : [];
        swipers.forEach(function(swiperContainer) {
            swiperContainer.__allSlidesCache = null;
        });
    }

    function warmCardSlideCache(cardOrRoot) {
        if (!cardOrRoot) return;
        const scope = cardOrRoot.matches && cardOrRoot.matches('.CollectionSliderCard')
            ? cardOrRoot
            : cardOrRoot;
        const swipers = scope.querySelectorAll
            ? scope.querySelectorAll('.CollectionSliderCard__InnerSlider')
            : [];
        swipers.forEach(function(swiperContainer) {
            // Build once from server-rendered full slide markup, before any variant filtering.
            ensureCardSlideCache(swiperContainer);
        });
    }

    function hydrateFirstSlideImage(swiperContainer) {
        if (!swiperContainer) return;
        const firstSlide = swiperContainer.querySelector('.swiper-slide:first-child');
        if (!firstSlide) return;
        const firstImg = firstSlide.querySelector('img.Image--lazyLoad');
        if (firstImg && firstImg.dataset.src && !firstImg.getAttribute('src')) {
            firstImg.setAttribute('src', firstImg.dataset.src);
            firstImg.classList.remove('Image--lazyLoad');
            firstImg.classList.add('Image--lazyLoaded');
        }
    }

    function applyVariantMediaRange(card, labelElement) {
        if (!card || !labelElement) return;

        const swiperContainer = card.querySelector('.CollectionSliderCard__InnerSlider');
        if (!swiperContainer) return;

        const allowedIds = parseMediaIds(labelElement.getAttribute('data-media-ids'));
        const selectedMediaId = (labelElement.getAttribute('data-first-media-id') || labelElement.getAttribute('data-media-id') || '').trim();
        const allSlides = ensureCardSlideCache(swiperContainer);
        if (!allSlides.length) return;

        const allowedSet = allowedIds.length ? new Set(allowedIds) : null;
        let filteredSlides = allowedSet
            ? allSlides.filter(function(item) { return allowedSet.has(item.id); })
            : allSlides.slice();

        if (!filteredSlides.length) {
            filteredSlides = allSlides.slice();
        }

        const targetIndex = Math.max(
            0,
            filteredSlides.findIndex(function(item) { return item.id === selectedMediaId; })
        );

        const slideHtml = filteredSlides.map(function(item) { return item.html; });
        const swiperInstance = swiperContainer.swiper;

        if (swiperInstance) {
            const wasAutoplayRunning = !!(swiperInstance.autoplay && swiperInstance.autoplay.running);
            if (swiperInstance.autoplay) {
                swiperInstance.autoplay.stop();
            }
            swiperInstance.removeAllSlides();
            swiperInstance.appendSlide(slideHtml);
            swiperInstance.update();
            swiperInstance.slideTo(targetIndex, 0, false);
            card.dataset.selectedMediaId = filteredSlides[targetIndex] ? filteredSlides[targetIndex].id : '';
            hydrateFirstSlideImage(swiperContainer);
            if (wasAutoplayRunning && swiperInstance.autoplay) {
                swiperInstance.autoplay.start();
            }
        } else {
            const wrapper = swiperContainer.querySelector('.swiper-wrapper');
            if (!wrapper) return;
            wrapper.innerHTML = slideHtml.join('');
            card.dataset.selectedMediaId = filteredSlides[targetIndex] ? filteredSlides[targetIndex].id : '';
            hydrateFirstSlideImage(swiperContainer);
        }
    }

    function resetCardToSelectedVariantMedia(card) {
        if (!card) return;
        const checkedInput = card.querySelector('.ProductItem__ColorSwatchList .ColorSwatch__Radio:checked');
        if (!checkedInput) return;
        const label = checkedInput.nextElementSibling && checkedInput.nextElementSibling.tagName === 'LABEL'
            ? checkedInput.nextElementSibling
            : null;
        if (!label) return;

        applyVariantMediaRange(card, label);
    }

    // 1. Hover Logic - Simplified
    if(!window.initCardHover) {
        window.initCardHover = function() {
            if(!canUseHover || window.innerWidth < 1024) return; 

            // Get all cards and attach hover listeners directly
            const cards = document.querySelectorAll('.CollectionSliderCard:not([data-hover-initialized])');
            cards.forEach(card => {
                // Mark as initialized
                card.dataset.hoverInitialized = 'true';

                // Use mouseenter/mouseleave on card to handle autoplay
                // This ensures autoplay continues even when hovering over image section
                let autoplayTimeout;
                
                card.addEventListener('mouseenter', function(e) {
                    // Don't trigger hover if modal is open
                    if(card.classList.contains('modal-open')) {
                        // On mobile only, ensure buttons remain visible when modal is open
                        if(window.innerWidth <= 767) {
                            const actionsSection = card.querySelector('.CollectionSliderCard__Actions');
                            if(actionsSection) {
                                actionsSection.style.opacity = '1';
                                actionsSection.style.visibility = 'visible';
                                actionsSection.style.display = 'flex';
                                actionsSection.style.pointerEvents = 'auto';
                            }
                        }
                        return;
                    }
                    
                    // Clear any pending timeout
                    clearTimeout(autoplayTimeout);

                    // Ensure hovered autoplay starts from currently selected variant range
                    resetCardToSelectedVariantMedia(card);
                    
                    // Start autoplay for swiper
                    const swiperContainer = card.querySelector('.CollectionSliderCard__InnerSlider');
                    if(swiperContainer && swiperContainer.swiper) {
                        const swiper = swiperContainer.swiper;
                        if(swiper.slides && swiper.slides.length > 1) {
                            if(swiper.autoplay) {
                                if(swiper.autoplay.running === false) {
                                    swiper.autoplay.start();
                                }
                            } else if(typeof Swiper !== 'undefined' && Swiper.Autoplay) {
                                swiper.params.autoplay = {
                                    delay: 2000,
                                    disableOnInteraction: false,
                                    pauseOnMouseEnter: false,
                                    stopOnLastSlide: false
                                };
                                swiper.autoplay = new Swiper.Autoplay(swiper);
                                swiper.autoplay.start();
                            }
                        }
                    }
                });

                card.addEventListener('mouseleave', function(e) {
                    // Don't stop if mouse is still over image section
                    const relatedTarget = e.relatedTarget;
                    if(relatedTarget && card.contains(relatedTarget)) {
                        return; // Mouse is still within card
                    }
                    
                    // Add small delay to prevent stopping when moving between card elements
                    autoplayTimeout = setTimeout(function() {
                        const swiperContainer = card.querySelector('.CollectionSliderCard__InnerSlider');
                        if(swiperContainer && swiperContainer.swiper && swiperContainer.swiper.autoplay) {
                            swiperContainer.swiper.autoplay.stop();
                        }
                        // When hover ends, return to selected variant featured image.
                        resetCardToSelectedVariantMedia(card);
                    }, 100);
                });
            });
        };
    }

    // 2. Variant Change Logic (Robust Global)
    if(!window.onVariantChangeSafe) {
        window.onVariantChangeSafe = function(el) {
          
            if (!el) return;
 
            let inputElement;
            let labelElement;

            if (el.tagName === 'LABEL') {
                labelElement = el;
                // Attempt to find sibling input (standard structure)
                const prev = el.previousElementSibling;
                if(prev && prev.tagName === 'INPUT') {
                    inputElement = prev;
                    inputElement.checked = true; 
                } else {
                    // Fallback: If not sibling, try ID
                    const forId = el.getAttribute('for');
                    if(forId) inputElement = document.getElementById(forId);
                }
            } else if (el.tagName === 'INPUT') {
                inputElement = el;
                labelElement = el.nextElementSibling; 
            }

            if (!inputElement) { console.warn("Variant Input not found"); return; }
            
            // If we found input but no label yet, try sibling
            if (!labelElement && inputElement.nextElementSibling && inputElement.nextElementSibling.tagName === 'LABEL') {
                 labelElement = inputElement.nextElementSibling;
            }

            if(!labelElement) { console.warn("Variant Label not found"); return; }

            const card = inputElement.closest('.ProductItem');
            if(!card) return;

            // Visually mark active swatch (class-based, independent of checked state)
            const allSwatchLabels = card.querySelectorAll('.ProductItem__ColorSwatchList .ColorSwatch');
            if (allSwatchLabels && allSwatchLabels.length) {
                allSwatchLabels.forEach(function(lbl) { lbl.classList.remove('is-active'); });
            }
            labelElement.classList.add('is-active');

            // Safe Get Attribute
            const getAttr = (elem, attr) => elem && elem.getAttribute ? elem.getAttribute(attr) : '';

            // Update card gallery to selected color media range
            applyVariantMediaRange(card, labelElement);

            // Update Price
            const price = getAttr(labelElement, 'data-price');
            const comparePrice = getAttr(labelElement, 'data-compare-price');
            const priceEl = card.querySelector('.ProductItem__PriceList .Price:not(.Price--compareAt)');
            const compareEl = card.querySelector('.ProductItem__PriceList .Price--compareAt');
            
            if(priceEl && price) priceEl.innerText = price;
            if(compareEl) {
                if(comparePrice) {
                    compareEl.innerText = comparePrice;
                    compareEl.style.display = '';
                } else {
                    compareEl.style.display = 'none';
                }
            }

            // Update Color Name
            const colorName = getAttr(inputElement, 'data-color-name') || getAttr(labelElement, 'data-color-name');
            const colorNameEl = card.querySelector('.ProductItem__ColorNameText');
            if(colorNameEl && colorName) {
                colorNameEl.innerText = colorName;
            }

            // Update Links
            const variantUrl = getAttr(labelElement, 'data-variant-url');
            if(variantUrl) {
                const shopBtn = card.querySelector('.CollectionSliderCard__ActionBtn--shop');
                const titleLink = card.querySelector('.ProductItem__Title a');
                const imageLink = card.querySelector('.CollectionSliderCard__ImageSection > a');

                if(shopBtn) shopBtn.href = variantUrl;
                if(titleLink) titleLink.href = variantUrl;
                if(imageLink) imageLink.href = variantUrl;
            }
            
            // Update VTO
            const sku = getAttr(inputElement, 'data-sku');
            const vtoBtns = card.querySelectorAll('.CollectionSliderCard__ActionBtn--vto');
            if (vtoBtns && vtoBtns.length && sku) {
                vtoBtns.forEach(btn => {
                    btn.setAttribute('onclick', "SprieSDK.Load('" + sku + "')");
                });
            }

            const homeTryOnBtnEls = card.querySelectorAll('[data-home-try-on-btn]');
            if (homeTryOnBtnEls && homeTryOnBtnEls.length) {
                const variantId = getAttr(inputElement, 'data-variant-id');
                homeTryOnBtnEls.forEach(function(homeTryOnBtnEl) {
                    if (variantId) {
                        homeTryOnBtnEl.setAttribute('data-variant-id', variantId);
                    }
                    if (sku) {
                        homeTryOnBtnEl.setAttribute('data-sku', sku);
                    }
                });
            }

            // Variant-level inventory & badge / button logic
            const inventoryRaw = getAttr(labelElement, 'data-inventory');
            const hasInventory = typeof inventoryRaw === 'string' && inventoryRaw !== '';
            const inventory = hasInventory ? parseInt(inventoryRaw, 10) : null;
            const inventoryPolicy = (getAttr(labelElement, 'data-inventory-policy') || '').toLowerCase();
            const continueSelling = inventoryPolicy === 'continue';

            const isTracked = hasInventory && typeof inventory === 'number' && !isNaN(inventory);
            const isComingSoon = isTracked && inventory < 0 && continueSelling;
            const isSoldOut = isTracked && inventory <= 0 && !continueSelling;
            const shouldShowNotify = isSoldOut;

            // Update badges on variant change
            const badgesContainer = card.querySelector('.CollectionSliderCard__Badges');
            if (badgesContainer) {
                // 1. Tag badges from variant metafield custom.variant_badge_text (max 2 total badges)
                badgesContainer.querySelectorAll('[data-variant-badge-tag]').forEach(function(el) { el.remove(); });
                const rawBadgeText = getAttr(labelElement, 'data-variant-badge-text');
                const soldOutBadgeRef = badgesContainer.querySelector('[data-variant-badge-sold-out]');
                const soldOutWillShow = isSoldOut;
                const tagSlotsAvailable = soldOutWillShow ? 1 : 2;
                if (rawBadgeText) {
                    let tagCount = 0;
                    rawBadgeText.split('||').forEach(function(tag) {
                        if (tagCount >= tagSlotsAvailable) return;
                        const t = tag.trim();
                        if (t) {
                            const span = document.createElement('span');
                            span.className = 'CollectionSliderCard__Badge';
                            span.setAttribute('data-variant-badge-tag', '');
                            span.textContent = t;
                            badgesContainer.insertBefore(span, soldOutBadgeRef);
                            tagCount++;
                        }
                    });
                }

                // 2. Sold Out badge — text and class from variant metafield custom.variant_sold_out_text
                const soldOutBadge = badgesContainer.querySelector('[data-variant-badge-sold-out]');
                if (soldOutBadge) {
                    const variantSoldOutText = (getAttr(labelElement, 'data-variant-sold-out-text') || '').trim();
                    const soldOutText = variantSoldOutText || soldOutBadge.getAttribute('data-fallback-text') || 'Sold Out';
                    const soldOutLower = soldOutText.toLowerCase();
                    const isNeutral = soldOutLower === 'coming soon' || soldOutLower === 'pre-order' || soldOutLower === 'pre order';
                    soldOutBadge.textContent = soldOutText;
                    soldOutBadge.className = isNeutral ? 'CollectionSliderCard__Badge' : 'CollectionSliderCard__Badge CollectionSliderCard__Badge--soldout';
                    soldOutBadge.style.display = isSoldOut ? '' : 'none';
                }
            }

            // Update primary action buttons (Shop Now vs Notify Me) for desktop & mobile
            const desktopShopBtn = card.querySelector('[data-variant-action="shop"]');
            const desktopDetailsBtn = card.querySelector('[data-variant-action="details"]');
            const desktopNotifyBtn = card.querySelector('[data-variant-action="notify"]');

            const mobileCartBtn = card.querySelector('[data-variant-action="shop-mobile"]');
            const mobileInfoBtn = card.querySelector('[data-variant-action="info-mobile"]');
            const mobileNotifyBtn = card.querySelector('[data-variant-action="notify-mobile"]');

            const showNotify = !!shouldShowNotify;
            const homeTryOnBtns = card.querySelectorAll('[data-home-try-on-btn]');
            if (homeTryOnBtns && homeTryOnBtns.length) {
                homeTryOnBtns.forEach(function(homeTryOnBtn) {
                    homeTryOnBtn.disabled = showNotify;
                });
            }

            if (desktopShopBtn) {
                desktopShopBtn.style.display = showNotify ? 'none' : '';
            }
            if (desktopDetailsBtn) {
                desktopDetailsBtn.style.display = showNotify ? '' : 'none';
            }
            if (desktopNotifyBtn) {
                desktopNotifyBtn.style.display = showNotify ? '' : 'none';
            }

            if (mobileCartBtn) {
                mobileCartBtn.style.display = showNotify ? 'none' : '';
            }
            if (mobileInfoBtn) {
                mobileInfoBtn.style.display = showNotify ? '' : 'none';
            }
            if (mobileNotifyBtn) {
                mobileNotifyBtn.style.display = showNotify ? '' : 'none';
            }
        };
    }

    // 3. Ensure first color swatch is selected & UI synced on load
    // Force-sync every radio group so only ONE radio is :checked.
    // Chrome bfcache / soft-load can silently restore stale checked
    // state AFTER DOMContentLoaded, so we run this multiple times.
    function forceRadioSync() {
        const cards = document.querySelectorAll('.CollectionSliderCard');
        if (!cards || !cards.length) return;

        cards.forEach(function(card) {
            const radios = card.querySelectorAll('.ProductItem__ColorSwatchList .ColorSwatch__Radio');
            if (!radios || !radios.length) return;

            // The correct default is the one with the HTML checked attribute
            var defaultRadio = card.querySelector('.ProductItem__ColorSwatchList .ColorSwatch__Radio[checked]');
            if (!defaultRadio) defaultRadio = radios[0];

            // Explicitly uncheck every radio, then check only the default
            radios.forEach(function(r) { r.checked = false; });
            defaultRadio.checked = true;

            window.onVariantChangeSafe(defaultRadio);
        });
    }

    // Init
    function initAll() {
        if(window.initCardHover) window.initCardHover();
        forceRadioSync();
        // Run again after a frame + microtask to beat Chrome's async form restore
        requestAnimationFrame(function() { setTimeout(forceRadioSync, 0); });
    }

    async function addHomeTryOnToCart(button) {
        if (!button || button.disabled) return;

        const variantId = button.getAttribute('data-variant-id');
        const sellingPlanId = button.getAttribute('data-selling-plan-id');
        if (!variantId || !sellingPlanId) return;

        button.disabled = true;
        button.classList.add('is-loading');

        try {
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    items: [{
                        id: Number(variantId),
                        quantity: 1,
                        selling_plan: Number(sellingPlanId)
                    }]
                })
            });

            if (!response.ok) {
                throw new Error('Failed to add home try on item');
            }

            document.dispatchEvent(new CustomEvent('product:added', {
                bubbles: true,
                detail: {
                    variant: { id: Number(variantId) },
                    quantity: 1
                }
            }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        } catch (error) {
            console.error('Home try on add-to-cart failed', error);
        } finally {
            button.disabled = false;
            button.classList.remove('is-loading');
        }
    }

    if (!window.collectionCardHomeTryOnBound) {
        document.addEventListener('click', function(event) {
            const button = event.target.closest('[data-home-try-on-btn]');
            if (!button) return;
            event.preventDefault();
            event.stopPropagation();
            addHomeTryOnToCart(button);
        });
        window.collectionCardHomeTryOnBound = true;
    }

    // Hovering a swatch previews media only; selection changes on click only.
    if (!window.collectionCardSwatchHoverBound) {
        document.addEventListener('mouseover', function(event) {
            if (!canUseHover) return;
            const swatchLabel = event.target.closest('.ProductItem__ColorSwatchList .ColorSwatch');
            if (!swatchLabel) return;

            const fromElement = event.relatedTarget;
            if (fromElement && swatchLabel.contains(fromElement)) {
                return;
            }
            const card = swatchLabel.closest('.ProductItem');
            if (!card) return;
            applyVariantMediaRange(card, swatchLabel);
        });

        document.addEventListener('mouseout', function(event) {
            if (!canUseHover) return;
            const swatchLabel = event.target.closest('.ProductItem__ColorSwatchList .ColorSwatch');
            if (!swatchLabel) return;

            const swatchList = swatchLabel.closest('.ProductItem__ColorSwatchList');
            const toElement = event.relatedTarget;
            if (swatchList && toElement && swatchList.contains(toElement)) {
                return;
            }

            const card = swatchLabel.closest('.ProductItem');
            if (!card) return;
            resetCardToSelectedVariantMedia(card);
        });

        window.collectionCardSwatchHoverBound = true;
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAll);
    } else {
        initAll();
    }

    // bfcache restore (back/forward navigation)
    window.addEventListener('pageshow', function(e) {
        if (e.persisted) initAll();
    });
    
    document.addEventListener('shopify:section:load', initAll);

    // Collection page uses this after AJAX DOM updates.
    window.CPResetCollectionCardMediaCache = function(rootEl) {
        if (rootEl && rootEl.querySelectorAll) {
            resetCardSlideCache(rootEl);
            return;
        }
        resetCardSlideCache(document);
    };

    window.CPWarmCollectionCardMediaCache = function(rootEl) {
        if (rootEl && rootEl.querySelectorAll) {
            warmCardSlideCache(rootEl);
            return;
        }
        warmCardSlideCache(document);
    };
})();